const mEditionInfo = {
  mEditionInfo: {
    account: 'Mi Cuenta',
    asset: 'Curso',
    billing: 'Gestión',

    actions: {
      goBack: 'volver atrás'
    }
  }
}

export default mEditionInfo
